import { Component, input, OnChanges, OnInit, output, SimpleChanges } from '@angular/core';
import { Modal } from 'flowbite';
import moment from 'moment';
import { IMessage } from 'src/app/models';
import { LiteralService, MessageService } from 'src/app/services';
import { images } from 'src/images';
import { TooltipPosition } from '../../tooltip/tooltip-position';
import { MessageChannel, MessageStatus } from 'src/app/models/enums';

@Component({
  selector: 'app-modal-message-detail',
  templateUrl: './modal-message-detail.component.html',
  styleUrl: './modal-message-detail.component.scss',
  standalone: false
})
export class ModalMessageDetailComponent implements OnInit, OnChanges {
  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly message = input<IMessage>();
  readonly list = input<any>();

  readonly userClickEmitter = output<number>();
  readonly updateList = output<any>();

  public images = images;
  public selectedStatus: MessageStatus = MessageStatus.FAILED;

  public subjectElement = {
    id: `subject`,
    img: images.messages.affair,
    title: 'messages.data.subject',
    value: ''
  }
  public receiverElement = {
    id: `receiver`,
    img: images.messages.receiver,
    title: 'messages.data.receiver',
    value: ''
  }

  public searchValue = '';

  public MessageChannels: any[] = [];
  public TooltipPosition = TooltipPosition;
  public MessageStatus = MessageStatus;

  constructor(
    public literalService: LiteralService,
    public messageService: MessageService
  ) { }

  ngOnInit(): void {
    Object.values(MessageChannel).map(
      (messageChannel: string) => {
        this.MessageChannels.push({
          icon: `${messageChannel.charAt(0).toLowerCase()}${messageChannel.slice(1)}`,
          tooltip: `messages.channel.${messageChannel.toLowerCase()}`
        });
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] && this.selectedStatus === MessageStatus.SUCCESS) {
      this.selectedStatus = MessageStatus.FAILED;
    }
    if (changes['message'] && changes['message'].currentValue) {
      this.searchValue = '';
      this.subjectElement.value = this.message()?.subject!;
      this.receiverElement.value = `${this.literalService.get('messages.receiver.' + this.message()?.receiver!.toLowerCase(), true)} - ${this.message()?.receiverName}`;
    }
  }

  getChannelIcon(channel: keyof typeof images.messages.channel) {
    return images.messages.channel[channel];
  }

  onChangePage(event: any) {
    this.updateList.emit({
      pagination: event,
      status: this.selectedStatus,
      searchValue: this.searchValue
    });
  }

  getChannelStatus(channel: string, index: number) {
    const channelStatus = this.list()?.value[index].channels.find((channelStatus: any) => channelStatus.channel.toLowerCase() === channel.toLowerCase());
    return channelStatus ? channelStatus.status : null;
  }

  checkChannelStatus(channel: string, index: number) {
    const channelStatus = this.getChannelStatus(channel, index);
    if (channelStatus) return `${channelStatus.toLowerCase()}-icon`;
    else return 'disabled-icon';
  }
  
  getTooltipText(channel: string, index: number) {
    const channelStatus = this.getChannelStatus(channel, index);
    if (channelStatus && channelStatus === MessageStatus.SUCCESS) return `<strong>${this.literalService.get('messages.tooltips.sent', true)}:</strong></br>${moment.utc(this.message()!.dateTime).local().format('DD/MM/YYYY')}</br>${moment.utc(this.message()!.dateTime).local().format('HH:mm')}`;
    else return ``;
  }

  onChangeMessageStatus() {
    if (this.selectedStatus === MessageStatus.FAILED) this.selectedStatus = MessageStatus.SUCCESS;
    else this.selectedStatus = MessageStatus.FAILED;
    this.updateList.emit({ 
      status: this.selectedStatus,
      searchValue: this.searchValue
    });
  }

  onSearch(event: any) {
    this.searchValue = event;
    this.updateList.emit({
      status: this.selectedStatus,
      searchValue: this.searchValue
    });
  }

  closeModal() {
    this.modal()!.hide();
  }
}
